import { useMemo } from 'react';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt, useCurrencyCultureInfo } from '@mews/framework';
import { Option } from '@mews-commander/types';
import { TransactionType } from '../../../../types';
import { getCashierTransactionValidationSchema } from './formMapping';
import { CurrencyInputField } from './CurrencyInputField';

interface Params {
    enabledCurrencies: string[];
}

const cashierTransactionOptions: Option[] = [
    {
        value: TransactionType.Received,
        label: lt('CashierTransactionTypeReceive'),
    },
    {
        value: TransactionType.Paid,
        label: lt('Paid'),
    },
].map(createOption);

const getCashierTransactionFormDefinition = (
    acceptedCurrencyCodes?: string[] | null
): SchemaFormDefinition<ReturnType<typeof getCashierTransactionValidationSchema>> => {
    const currencies = acceptedCurrencyCodes ?? [];
    return {
        fields: {
            currency: {
                label: lt('Currency'),
                readOnly: currencies.length === 1,
                field: {
                    type: 'select',
                    options: currencies.map((a) => createOption({ value: a, label: a })),
                },
            },
            type: {
                label: lt('TypeOfTransaction'),
                field: {
                    type: 'select',
                    options: cashierTransactionOptions,
                },
            },
            value: { label: lt('Value'), render: (props) => <CurrencyInputField {...props} /> },
            notes: {
                label: lt('Notes'),
                field: {
                    type: 'textarea',
                },
            },
        },
        renderFields: ['currency', 'type', 'value', 'notes'],
    };
};
export const CashierTransactionFormContent = ({ enabledCurrencies }: Params) => {
    const localizationInfo = useCurrencyCultureInfo();
    const cashierTransactionFormDefinition = useMemo(
        () => getCashierTransactionFormDefinition(enabledCurrencies),
        [enabledCurrencies]
    );

    return (
        <SchemaFormFields
            schema={getCashierTransactionValidationSchema(enabledCurrencies, localizationInfo)}
            formDefinition={cashierTransactionFormDefinition}
        />
    );
};
